/**
 * Reply Button Component
 * 
 * Button that appears on message hover to allow replying to a message.
 */ 

import React from 'react';
import { Button, Tooltip } from 'antd';
import { EnterOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { useResponsive } from '@municipality/ui';

interface ReplyButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const StyledReplyButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== '$isMobile',
})<{ $isMobile: boolean }>`
  padding: 0;
  width: ${({ $isMobile }) => ($isMobile ? '44px' : '20px')};
  height: ${({ $isMobile }) => ($isMobile ? '44px' : '20px')};
  min-width: ${({ $isMobile }) => ($isMobile ? '44px' : '20px')};
  min-height: ${({ $isMobile }) => ($isMobile ? '44px' : '20px')};
  border: none;
  box-shadow: none;
  color: #b5002a;
  display: flex;
  align-items: center;
  justify-content: center;
  
  &:hover:not(:disabled) {
    color: #b5002a;
    opacity: 0.8;
    background-color: transparent;
  }
  
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const ReplyButton: React.FC<ReplyButtonProps> = ({ onClick, disabled }) => {
  const { t } = useTranslation('chat');
  const { isMobile } = useResponsive();
  
  return (
    <Tooltip title={t('threading.reply') || 'Reply'}>
      <StyledReplyButton
        type="text"
        size="small"
        icon={<EnterOutlined />}
        onClick={onClick}
        disabled={disabled}
        $isMobile={isMobile}
      />
    </Tooltip>
  );
};
